const ENQUEUE_MODAL = 'ENQUEUE_MODAL';
const CLOSE_MODAL = 'CLOSE_MODAL';

const enqueueModal = (modal) => ({
    type: ENQUEUE_MODAL,
    modal
});

const closeModal = () => ({
    type: CLOSE_MODAL
});

export function handleCloseModal() {
    return (dispatch) => {
        document.body.style.overflow = '';
        dispatch(closeModal());
    };
}

export function handleEnqueueModal(modal) {
    return (dispatch, getState) => {
        const { isOpen } = getState();
        let timeElapse = 0;

        if (isOpen) {
            dispatch(handleCloseModal());
            timeElapse = 500;
        }

        setTimeout(() => {
            document.body.style.overflow = 'hidden';
            dispatch(enqueueModal(modal));
        }, timeElapse);
    };
}

const INITIAL_STATE = {
    isOpen: false,
    title: null,
    body: null,
    footer: null,
    isCloseIfClickOutside: true,
    isShowCloseIcon: true
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ENQUEUE_MODAL: {
            const { modal } = action;

            return {
                ...state,
                ...modal,
                isOpen: true
            };
        }

        case CLOSE_MODAL:
            return INITIAL_STATE;

        default:
            return state;
    }
};
